import React from 'react';
import ProductInquiryCard from '../../components/ProductInquiryCard';

const PMS = () => {
  const strategies = [
    { 
      name: "Multicap High-Conviction Compounders", 
      min: "₹50 Lakhs", 
      returnProfile: "18-22% Target CAGR", 
      desc: "Direct equity holding of 15-20 industry leaders with zero corporate leverage and high ROE." 
    },
    { 
      name: "Small & Midcap Alpha Mandate", 
      min: "₹50 Lakhs", 
      returnProfile: "20-25% Target Alpha", 
      desc: "Agile, institutional small-cap growth champions poised for rapid earnings acceleration." 
    },
    { 
      name: "Value & Special Situations Strategy", 
      min: "₹50 Lakhs", 
      returnProfile: "Downside Protected", 
      desc: "Deep contrarian stock picking, corporate restructuring plays, and de-merger arbitrages." 
    }
  ];

  return (
    <div className="min-h-screen bg-[#07131F] text-slate-100 selection:bg-[#16325B] selection:text-white pb-20">
      <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 border-b border-slate-800/80">
        <div className="max-w-5xl mx-auto relative z-10 text-center">
          {/* <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#16325B]/40 border border-blue-500/30 text-[#60A5FA] text-xs sm:text-sm font-semibold mb-6">
            <span className="w-2 h-2 rounded-full bg-[#60A5FA] animate-pulse"></span>
            SEBI Regulated / Direct Demat Equity Ownership
          </div> */}
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-serif font-bold text-white tracking-tight leading-tight">
            Portfolio Management Services <span className="text-[#60A5FA]">(PMS)</span>
          </h1>
          <p className="mt-4 text-base sm:text-lg text-slate-300 max-w-2xl mx-auto">
            Direct ownership of curated equities in your personal Demat account, discretionary active alpha, and institutional risk governance.
          </p>
        </div>
      </section>

      <section className="py-10 bg-[#091B2C] border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">SEBI Minimum Ticket</div>
            <div className="text-2xl font-bold text-[#60A5FA] font-mono mt-1">₹50,00,000</div>
          </div>
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Ownership Model</div>
            <div className="text-2xl font-bold text-white font-serif mt-1">Direct Demat Holding</div>
          </div>
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Reporting</div>
            <div className="text-2xl font-bold text-blue-300 font-serif mt-1">Real-Time Ledger</div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 space-y-4">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-6">Flagship PMS Strategies</h2>
            {strategies.map((st, i) => (
              <div 
                key={i} 
                className="p-6 rounded-2xl bg-[#0B1E30]/80 backdrop-blur-sm border border-slate-700/60 hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/10 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-lg font-bold text-white">{st.name}</h3>
                  <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-[#16325B]/40 text-[#60A5FA] border border-blue-500/20 font-mono">
                    {st.returnProfile}
                  </span>
                </div>
                <p className="text-sm text-slate-300 leading-relaxed mb-3">{st.desc}</p>
                <div className="text-xs text-slate-400 font-mono">SEBI Minimum Mandate: {st.min}</div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-5 sticky top-24">
            <ProductInquiryCard
              title="Consult Portfolio Desk"
              subtitle="Schedule an executive strategy session with our SEBI certified portfolio managers."
              productName="Portfolio Management Services (PMS)"
              defaultTicket="₹50,00,000 (SEBI Mandated)"
              buttonText="Connect With Portfolio Manager"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default PMS;